import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-6787 — returns true when IS_PII_ADVANCED_RULES_FEATURE_ENABLED is
// set to "true" on the server. Split from the custom-entities flag: this one
// gates only the "PII detection rules (advanced)" section (entity allowlist +
// score threshold), whose /pii-settings endpoint 404s while it is off.
export const usePiiAdvancedRulesFeatureEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isPiiAdvancedRulesFeatureEnabled ?? false;
};
